import ChartDataLabels from "chartjs-plugin-datalabels";
import { Radar as ChartRadar } from "react-chartjs-2";
import React from "react";
import { defaultOptions } from "./config/options";

const Radar = ({
  width,
  height,
  labels,
  dataset,
  moreDatasets,
  options,
  backgroundColor,
  borderColor,
  config,
}) => {
  let datasets = [
    {
      label: "Akurasi (%)",
      data: dataset,
      backgroundColor: "rgba(84, 70, 205, 0.2)",
      borderColor: "#5446CD",
      ...config,
    },
  ];

  if (moreDatasets) {
    datasets = datasets.concat(moreDatasets);
  }

  const data = {
    labels: labels,
    datasets: datasets,
  };

  return (
    <ChartRadar
      plugins={[ChartDataLabels]}
      options={options || defaultOptions}
      data={data}
      width={width}
      height={height}
    />
  );
};

export default Radar;
